import { VFC } from 'react';
import { hesselViewModels } from '../../../../lib/view-models';
import { CollapsibleItem } from '../collapsible-item';
import { StyledHeader, StyledLi, StyledText, StyledUl } from '../equipment-dialog.styled';
import { StyledContainer, StyledEquipmentPackage, StyledPackagesContainer } from './included-equipment-package.styled';
import { getEquipmentPackagesIncludedInPackage, isEquipmentIncludedInCheaperPackage } from '../../../../utils/helpers/equipment-package.helpers';

type IncludedEquipmentPackageProps = {
    equipmentPackages: hesselViewModels.EquipmentPackage[];
};

export const IncludedEquipmentPackage: VFC<IncludedEquipmentPackageProps> = ({ equipmentPackages }) => {
    return (
        <StyledContainer>
            <StyledHeader>ANDET INDHOLD</StyledHeader>
            <StyledPackagesContainer>
                {equipmentPackages.map((e) => (
                    <StyledEquipmentPackage key={`equipment-package-${e.id}`}>
                        <StyledHeader>{e.name}</StyledHeader>
                        <StyledUl>
                            {e.equipment
                                .filter((eq) => !isEquipmentIncludedInCheaperPackage(eq, e, equipmentPackages))
                                .map((stdEqpPackage, index) => {
                                    return (
                                        <StyledLi key={`standard-equipment-package-item-${stdEqpPackage.id}-${e.id}:${index}`}>
                                            {!stdEqpPackage.description ? (
                                                <StyledText>{stdEqpPackage.name}</StyledText>
                                            ) : (
                                                <CollapsibleItem
                                                    name={stdEqpPackage.name}
                                                    description={stdEqpPackage.description}
                                                    resources={stdEqpPackage.resources}
                                                />
                                            )}
                                        </StyledLi>
                                    );
                                })}
                        </StyledUl>
                        {!!e?.includedPackageIdKeys && e.includedPackageIdKeys.length > 0 && (
                            <IncludedEquipmentPackage
                                equipmentPackages={getEquipmentPackagesIncludedInPackage(equipmentPackages, e.includedPackageIdKeys)}
                            />
                        )}
                    </StyledEquipmentPackage>
                ))}
            </StyledPackagesContainer>
        </StyledContainer>
    );
};
